export default __webpack_public_path__ + "static/media/read_write3.a484733d.png";